import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/login/auth-layout.component';
// import { MapComponent } from './modules/map/map/map.component';
const routes: Routes =
  [
    // { path: '', pathMatch: 'full', redirectTo: 'login' },
    { path: 'login', component: AuthLayoutComponent },
    {
      path: '',
      // canActivate: [NoAuthGuard],
      // canActivateChild: [NoAuthGuard],
      component: AuthLayoutComponent,
      children: [
        // {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
        // {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
        // {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
        // {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
        // {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
      ]
    },
    { path: 'dashboard', component: LayoutComponent, loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), },
    { path: 'metrics', component: LayoutComponent, loadChildren: () => import('./modules/market-matrics/market-matrics.module').then(m => m.MarketMatricsModule), },
    { path: 'all-lanes', redirectTo: 'metrics/all-lanes', pathMatch: 'full' },
    { path: 'lanes', component: LayoutComponent, loadChildren: () => import('./modules/lane/lane.module').then(m => m.LaneModule), },
    { path: 'map', component: LayoutComponent, loadChildren: () => import('./modules/map/map.module').then(m => m.MapModule), },
    // { path: 'analytics', component: LayoutComponent, loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule), },
    { path: 'user', component: LayoutComponent, loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule) },
    { path: 'organization', component: LayoutComponent, loadChildren: () => import('./modules/organization/organization.module').then(m => m.OrganizationModule) },
    { path: 'plans', component: LayoutComponent, loadChildren: () => import('./modules/plans/plans.module').then(m => m.PlansModule) },
    { path: 'setting', component: LayoutComponent, loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule) },
    { path: 'blogs', component: LayoutComponent, loadChildren: () => import('./modules/blog-management/blog-management.module').then(m => m.BlogManagementModule) },
    { path: 'ports', component: LayoutComponent, loadChildren: () => import('./modules/ports/ports.module').then(m => m.PortsModule) },
    { path: 'terminology', component: LayoutComponent, loadChildren: () => import('./modules/terminology/terminology.module').then(m => m.TerminologyModule) },
    { path: 'currency', component: LayoutComponent, loadChildren: () => import('./modules/currency/currency.module').then(m => m.CurrencyModule) },
    { path: 'price', component: LayoutComponent, loadChildren: () => import('./modules/add-price/add-price.module').then(m => m.AddPriceModule) },
    { path: 'master', component: LayoutComponent, loadChildren: () => import('./modules/master/master.module').then(m => m.MasterModule) },
    { path: '**', component: AuthLayoutComponent },
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
